export const reportsAvailable = [
  {
    id: 1,
    label: 'Reported & removed links - per platform',
    report_type: 'ReportedRemovedPerPlatforms'
  },
  {
    id: 2,
    label: 'All Campaigns',
    report_type: 'AllCampaigns'
  },
  {
    id: 3,
    label: 'All Non-Removed Links - per platform',
    report_type: 'AllNonRemovedLinksPerPlatform'
  },
  {
    id: 4,
    label: 'All Non-Reported Links - per platform',
    report_type: 'AllNonReportedLinksPerPlatform'
  },
  {
    id: 5,
    label: 'Whitelist channels',
    report_type: 'WhitelistChannels'
  },
  {
    id: 6,
    label: 'All Campaigns IDs and Status - Per Customer',
    report_type: 'AllCampaignsIDsAndStatusPerCustomer'
  },
  {
    id: 7,
    label: 'Monetization & Retracted - per platform',
    report_type: 'MonetizationRetractedPerPlatform'
  },
  {
    id: 8,
    label: 'Pending Reported - per platform',
    report_type: 'PendingReportedPerPlatform'
  },
  {
    id: 9,
    label: 'Pending Not Reported - per platform',
    report_type: 'PendingNotReportedPerPlatform'
  },
  {
    id: 10,
    label: 'Reported & Removed + Pending Not Reported',
    report_type: 'ReportedRemovedAndPendingNotReported'
  }
]

export const REPORTS_WITH_CUSTOMER = [1, 5, 6, 7, 8, 9, 10]
export const REPORTS_WITH_PLATFORM = [1, 3, 4, 5, 7, 8, 9, 10]
export const REPORTS_WITH_LINK_STATUS = [7]
export const REPORTS_WITH_DATES = [1, 7, 8, 9, 10]
export const REPORTS_WITH_DATE_FIELD = [1]
